import styled from 'styled-components'

export const Detail = styled.div<{ isopen: string }>`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 100;
  word-break: break-word;

  .overlay {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    opacity: 0;
    will-change: opacity;
    pointer-events: none;
    transition: opacity 0.3s cubic-bezier(0, 0, 0.3, 1);
  }

  ${({ isopen }) => isopen === 'true' && '.overlay { opacity: 1; pointer-events: auto; }'}

  .wrap {
    position: fixed;
    box-sizing: border-box;
    height: 100%;
    width: 420px;
    padding: 0;
    background: #111;
    border-left: 1px solid rgba(255, 255, 255, 0.07);
    overflow-y: auto;
    overflow-x: hidden;
    transform: translateX(100%);
    will-change: transform;
    z-index: 101;
    pointer-events: auto;
    transition: transform 130ms ease-out;
    right: 0;

    @media only screen and (max-width: 510px) {
      width: 100%;
    }
  }

  ${({ isopen }) =>
    isopen === 'true' && '.wrap { transform: none; pointer-events: auto; transition: transform 330ms ease-in; }'}
`

export const ButtonColor = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  padding: 0 14px;
  background: rgba(111, 92, 230, 0.1);
  border: 1px solid rgba(111, 92, 230, 0.25);
  border-radius: 6px;
  color: #a89aff;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
  width: 100%;

  &:hover {
    background: rgba(111, 92, 230, 0.18);
    border-color: rgba(111, 92, 230, 0.4);
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`

export const NotificationsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 20px;
`

export const AllNotificationsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  div {
    width: 100%;
    box-sizing: border-box;
  }
`

// Legacy export — kept for backward compat
export const PasswordForm = styled.div`
  padding: 10px 20px;
  background: #161616;
  border-radius: 8px;
  margin-bottom: 20px;
`
